import React, { Component } from "react";
import { getDateData } from "../common/HelperFunctions";
import Payment from "../common/Payment";
import { Loader } from "./Transactions";

export default class payouts extends Component {
  render() {
    return (
      <div>
        {this.props.payments ? (
          <>
            {this.props.payments.payouts.length > 0 ? (
              <>
                {[...this.props.payments.payouts].reverse().map((payout) => (
                  <Payment
                    {...payout}
                    cost={payout.amount_due}
                    title={payout.reference}
                    mini_text={getDateData(payout.created_at, false, true)}
                  />
                ))}
              </>
            ) : (
              <p className="end">You currently have no payouts</p>
            )}
          </>
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}
